<template>
  <div class="step-content">
    <span><span class="number-step"># 1 - </span>Accéder aux « <strong>Paramètres</strong> »</span>
    <span class="target">
      <img class="screen-tuto" src="../../assets/tuto/screen-1-step-1.png" />
    </span>
    <span>pour sélectionner les démonstrations verres Essilor disponibles dans l'outil</span>
    <img class="screen-tuto" src="../../assets/tuto/screen-2-step-1.png" />
  </div>
</template>

<script>
export default {
  name: 'Step1',
};
</script>

<style scoped>
.step-content {
  padding: 0 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
}
.screen-tuto {
  width: 300px;
}
.number-step {
  font-weight: bolder;
  font-size: 30px;
  color: #0088ec;
}
.target {
  position: relative;
}
strong {
  font-size: 20px;
  color: black;
}
.target::after {
  content: '';
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 2px dashed #0088ec;
  position: absolute;
  top: 16px;
  right: 50px;
}
</style>
